import { render } from "./ModalItem.vue?vue&type=template&id=abeee560&scoped=true"
import script from "./ModalItem.vue?vue&type=script&lang=js"
export * from "./ModalItem.vue?vue&type=script&lang=js"

import "./ModalItem.vue?vue&type=style&index=0&id=abeee560&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abeee560"]])

export default __exports__